<template>
  <!-- toast -->
  <AlertMsg
    :msg="msgObj.msg"
    :show="msgObj.show"
    :role="msgObj.role"
    @closePopup="msgObj.show = false"
  ></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <h5 class="mb-0 text-primary">
          <i class="text-primary fas fa-calendar"></i> Exam Setup
        </h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">
            Exam Type<sup><span class="text-danger font-12">*</span></sup> :
          </label>
          <div class="dropdown">
            <button
              class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ examList.find((c) => c._id === Obj.examTypeID)?.Name || "" }}
            </button>
            <ul class="dropdown-menu w-100 scrollable-menu">
              <li
                v-for="(item, index) in examList"
                :key="index"
                :value="item.Name"
              >
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="Obj.examTypeID = item._id"
                >
                  {{ item.Name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">
            Class<sup><span class="text-danger font-12">*</span></sup> :
          </label>
          <div class="dropdown">
            <button
              class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ clsList.find((c) => c._id === Obj.clsID)?.name || "" }}
            </button>
            <ul class="dropdown-menu w-100 scrollable-menu">
              <li v-for="(item, index) in uniqueClsList" :key="index">
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="Obj.clsID = item._id"
                >
                  {{ item.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label"
            >Section<sup><span class="text-danger font-12">*</span></sup>
            :</label
          >
          <select
            class="form-select form-select-sm rounded cursor-pointer"
            role="button"
            v-model="Obj.sectionID"
          >
            <option selected=""></option>
            <option
              v-for="(item, index) in secList"
              :key="index"
              :value="item._id"
            >
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">
            Duplicate<sup><span class="text-danger font-12"></span></sup> :
          </label>
          <div class="dropdown">
            <button
              class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              :disabled="!Obj.examTypeID || !Obj.clsID"
            >
              {{ dupCls }}
            </button>
            <ul class="dropdown-menu w-100 scrollable-menu">
              <li
                v-for="(item, index) in duplicateClasses"
                :key="index"
              >
                <span class="dropdown-item" @click="bindDup(item.class)">
                  {{ item.class }}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="col-md-12"
          v-for="(subject, index) in SavedSubjects"
          :key="'saved-' + index"
        >
          <div class="row align-items-end">
            <div class="col-md-3">
              <label class="form-label">Subject :</label>
              <div class="border-a">
                {{ subject.subID }}
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Total Marks :</label>
              <div class="border-a">
                {{ subject.totalMarks }}
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Pass Marks :</label>
              <div class="border-a">
                {{ subject.passMark }}
              </div>
            </div>
            <div class="col-md-3 d-flex gap-2">
              <i
                class="fa fa-times-circle text-danger fa-2x mt-2 cursor-pointer"
                role="button"
                @click="removeSavedSubject(index)"
              ></i>
            </div>
          </div>
        </div>
        <div
          class="col-md-12"
          v-for="(subjectEntry, index) in Obj.Subjects"
          :key="index"
        >
          <div class="row align-items-end">
            <div class="col-md-3">
              <label class="form-label"
                >Subject<sup><span class="text-danger font-12">*</span></sup>
                :</label
              >
              <select
                class="form-select form-select-sm rounded cursor-pointer"
                role="button"
                v-model="subjectEntry.subID"
              >
                <option selected></option>
                <option
                  v-for="(item, i) in filteredSubjects"
                  :key="i"
                  :value="item.name"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label"
                >Total Marks<sup
                  ><span class="text-danger font-12">*</span></sup
                >
                :</label
              >
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="subjectEntry.totalMarks"
              />
            </div>
            <div class="col-md-3">
              <label class="form-label"
                >Pass Marks<sup><span class="text-danger font-12">*</span></sup>
                :</label
              >
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="subjectEntry.passMark"
              />
            </div>
            <div class="col-md-3 d-flex gap-2">
              <i
                class="fa fa-times-circle fa-2x text-danger mt-2 cursor-pointer"
                role="button"
                v-if="index !== Obj.Subjects.length - 1"
                @click="removeSubject(index)"
              ></i>
              <i
                class="fa fa-plus-circle fa-2x text-success mt-2 cursor-pointer"
                role="button"
                v-if="index === Obj.Subjects.length - 1"
                @click="addSubject(subjectEntry)"
              ></i>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-end">
          <button
            class="btn btn-darknavy btn-sm me-1"
            @click="save()"
            :disabled="SavedSubjects.length == 0"
          >
            <i class="fa fa-save"></i> Save
          </button>
          <button
            type="button"
            class="btn btn-sm btn-soft-dark"
            @click="reset()"
          >
            <i class="fa fa-times-circle me-1"></i> Cancel
          </button>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
      <div class="row mt-3">
        <div class="col-md-12 table-responsive">
          <div class="progress mb-0 progress-sm" v-if="progress != 0">
            <div
              class="progress-bar"
              role="progressbar"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
              :style="{ width: progress + '%' }"
            ></div>
          </div>
          <DataTable
            v-if="progress == 0"
            :columns="cols"
            :rows="rows"
            :pageSize="10"
            :actions="{ edit: handleEdit, delete: handleDelete }"
          />
        </div>
      </div>
    </div>
  </div>
  <DelPopup
    :name="delObj.examTypeID"
    @delRecord="delRecord"
    @closeModal="delObj.examTypeID = ''"
  ></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { curdStatus, api } from "@/utils/helpers.js";
import { ref, onMounted, computed } from "vue";
import { schoolStore } from "@/utils/schoolStore";
const { clsList, uniqueClsList, secList, examList, subList } = schoolStore();
const Obj = ref({
  examTypeID: "",
  clsID: "",
  sectionID: "",
  Subjects: [{ subID: "", totalMarks: "", passMark: "" }],
});
const SavedSubjects = ref([]);
const msgObj = ref({ msg: "", role: "", show: false });
const delObj = ref({});
const errors = ref({});
const dupCls = ref("");
const cols = ref([
  { label: "S.No", key: "Sno" },
  { label: "Exam Type", key: "examName" },
  { label: "Class", key: "class" },
  { label: "Subject", key: "subID" },
  { label: "Total Marks", key: "totalMarks" },
  { label: "Pass Marks", key: "passMark" },
]);
const bindDup = (cls) => {
  dupCls.value = cls;
  SavedSubjects.value.push(
    ...rows.value.filter(
      (item) =>
        item.examTypeID === Obj.value.examTypeID && item.class === cls,
    ),
  );
  SavedSubjects.value = SavedSubjects.value.map((subject) => {
    const newSubject = { ...subject };
    newSubject.examTypeID = Obj.value.examTypeID;
    newSubject.clsID = Obj.value.clsID;
    newSubject.sectionID = Obj.value.sectionID;
    delete newSubject._id;
    return newSubject;
  });
};
const handleEdit = (row) => {
  Obj.value = {
    examTypeID: row.examTypeID || "",
    clsID: row.clsID || "",
    sectionID: row.sectionID || "",
    Subjects: [
      {
        _id: row._id,
        subID: row.subID,
        totalMarks: row.totalMarks,
        passMark: row.passMark,
      },
    ],
  };
};

const handleDelete = (row) => {
  delObj.value = { ...row };
};
const rows = ref([]);
const duplicateClasses = computed(() => {
  const examRows = rows.value.filter(
    (item) => item.examTypeID === Obj.value.examTypeID,
  );
  return [...new Map(examRows.map((item) => [item.class, item])).values()];
});
const filteredSubjects = computed(() => {
  if (!Obj.value.clsID) return [];
  return subList.value.filter((s) => s.clsID === Obj.value.clsID);
});

const addSubject = async (subMark) => {
  const current = {
    ...subMark,
    examTypeID: Obj.value.examTypeID,
    clsID: Obj.value.clsID,
    sectionID: Obj.value.sectionID,
  };

  const fieldErrors = validateForm({
    ExamType: { value: current.examTypeID, validators: [isRequired] },
    Class: { value: current.clsID, validators: [isRequired] },
    Section: { value: current.sectionID, validators: [isRequired] },
    Subject: { value: current.subID, validators: [isRequired] },
    TotalMarks: { value: current.totalMarks, validators: [isRequired] },
    PassMarks: { value: current.passMark, validators: [isRequired] },
  });

  if (Object.keys(fieldErrors).length) {
    errors.value = fieldErrors;
    return;
  }
  if (parseFloat(current.passMark) > parseFloat(current.totalMarks)) {
    msgObj.value = {
      msg: "Pass Marks cannot be greater than Total Marks",
      role: "danger",
      show: true,
    };
    return;
  }
  SavedSubjects.value.push({ ...current });
  Obj.value.Subjects = [{ subID: "", totalMarks: "", passMark: "" }];
  errors.value = {};
};

const removeSavedSubject = async (index) => {
  SavedSubjects.value.splice(index, 1);
};
const save = async () => {
  for (const subject of SavedSubjects.value) {
    if (parseFloat(subject.passMark) > parseFloat(subject.totalMarks)) {
      msgObj.value = {
        msg: "Pass Marks cannot be greater than Total Marks",
        role: "danger",
        show: true,
      };
      return;
    }

    const duplicate = rows.value.find(
      (r) =>
        r.examTypeID === subject.examTypeID &&
        r.clsID === subject.clsID &&
        r.sectionID === subject.sectionID &&
        r.subID === subject.subID &&
        r._id !== subject._id,
    );

    if (duplicate) {
      msgObj.value = {
        msg: "ExamSetup Already Exists",
        role: "danger",
        show: true,
      };
      continue;
    }

    const { url, method, msg } = curdStatus(subject);
    await api[method](`/exmsetup/${url}`, subject)
      .then(() => {
        loadData();
        reset();
        msgObj.value = {
          msg: `ExamSetup ${msg} Successfully`,
          role: "success",
          show: true,
        };
      })
      .catch((error) => console.log(error));
  }
};

const reset = async () => {
  Obj.value = {
    examTypeID: "",
    clsID: "",
    sectionID: "",
    Subjects: [{ subID: "", totalMarks: "", passMark: "" }],
  };
  dupCls.value = "";
  msgObj.value = { msg: "", role: "", show: false };
  errors.value = {};
  SavedSubjects.value = [];
};
const progress = ref(0);
const loadData = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);
  await api.get("/exmsetup/all").then((response) => {
    rows.value = response.data.map((item, i) => ({
      ...item,
      Sno: i + 1,
      examTypeID: item.examTypeID,
      examName:
        examList.value.find((c) => c._id === item.examTypeID)?.Name || "",
      class: `${clsList.value.find((c) => c._id === item.clsID)?.name || ""}${
        clsList.value.find((c) => c._id === item.clsID)?.name
          ? secList.value.find((s) => s._id === item.sectionID)?.Name
            ? " (" +
              secList.value.find((s) => s._id === item.sectionID)?.Name +
              ")"
            : ""
          : ""
      }`,
    }));
    progress.value = 0;
    clearInterval(progressInterval);
  });
};
const delRecord = async () => {
  await api.delete(`/exmsetup/${delObj.value._id}`).then(() => {
    loadData();
    delObj.value = {};
    msgObj.value = {
      msg: "EaxmSetup Deleted Successfuly.",
      role: "danger",
      show: true,
    };
  });
};
onMounted(() => {
  loadData();
});
</script>
<style>
.border-a {
  border: 1px solid #c2bbbb;
  padding: 7px;
  border-radius: 5px;
}
</style>
